import React from 'react';
import { useNavigate } from 'react-router-dom';

const vendorData = [
  {
    id: 1,
    title: 'Agent',
    image: 'images/agent-1.jpg',
    route: 'HireAgent'
  },
  {
    id: 2,
    title: 'Lawyer',
    image: 'images/agent-13.jpg',
    route: 'HireLawyer'
  },
  {
    id: 3,
    title: 'Property Evaluators',
    image: 'images/agent-17.jpg',
    route: 'PropertyEvaluators'
  }
];

const socialLinks = [
  { icon: 'fab fa-twitter' },
  { icon: 'fab fa-facebook-f' },
  { icon: 'fab fa-skype' },
  { icon: 'fab fa-linkedin-in' }
];

function Vendors() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const checkAuthentication = (url) => {
    if (!token) {
      navigate('/Login');
    } else {
      navigate(`/${url}`);
    }
  };

  return (
    <section className="vendor-main container">
      <div className="mb-5 mt-5">
        <h5 className="fw-bold">Hire Vendor</h5>
      </div>

      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-4">
        {vendorData.map((vendor) => (
          <div key={vendor.id} className="col mb-4">
            <div className="card shadow-hover-xs-4 h-100">
              <div className="card-body text-center p-4">
                <div className="mb-3">
                  <img 
                    src={vendor.image} 
                    alt={vendor.title} 
                    className="img-fluid rounded-circle"
                    style={{ width: '120px', height: '120px', objectFit: 'cover' }}
                  />
                </div>
                
                <h5 className="card-title mb-3">
                  {vendor.title}
                </h5>

                <button 
                  onClick={() => checkAuthentication(vendor.route)}
                  className="btn btn-primary w-100"
                >
                  Hire Me
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Vendors;